export { ForgotPassword as default } from "./forgot-password";
